import { put, call } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { OK } from '../../../configs/serverStatusCodes';
import {
  loadClientByIdFailed,
  loadClientByIdSuccessful,
} from '../actions';

export default function* loadClientById(action) {
  try {
    const id = action.payload;

    const url = `${BACKEND_URL}/clients/${id}`;
    const dataResponse = yield makeRequest(url, { with_parking_zone: 1 }, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadClientByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadClientByIdFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadClientByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
